/**
 * Selector-parity — legacy `generetionTimeStamp()`.
 *
 * Every rating dialog on the Backbone side carries a byte-identical copy of
 * this function (coil.selector.js:4213, ewheel.selector.js, fan.selector.js,
 * plate_heat_exchanger.selector.js, …) and stamps its result into the
 * component's `rating_datetime` / `rated_datetime` column on Select. The
 * format is fixed and load-bearing: those columns are plain `varchar`s, and
 * everything downstream — the print sheets' "Rated on:" line, the reports, and
 * any ordering query — assumes `YYYY.MM.DD_HH:mm:ss`. Every one of the 3000+
 * legacy-written rows on dev3 is in that shape.
 *
 * `new Date().toLocaleString()` is NOT a substitute: it yields
 * `"9/3/2026, 8:30:00 AM"`, which is locale- and timezone-dependent, sorts
 * wrongly as text, and does not parse back. Two selectors had drifted onto it.
 */
export function generateRatingTimestamp(now: Date = new Date()): string {
  const p = (n: number) => (n < 10 ? `0${n}` : String(n));
  return (
    `${now.getFullYear()}.${p(now.getMonth() + 1)}.${p(now.getDate())}_` +
    `${p(now.getHours())}:${p(now.getMinutes())}:${p(now.getSeconds())}`
  );
}
